<template lang="html">
  <section class="page">

      <page-header :header="title" />






<!-- <div class="card" style="width: 15rem">
  <span class="card-img-top youtube" id="C6-qCnIsNjs" style="height: 300px" alt="Card image cap"></span>
  <div class="card-block">
    <h4 class="card-title">Recording #1: Program Goals, Objectives and Performance Indicators Webinar</h4>

  </div>
  <div class="card-footer">
      <small class="text-muted">Added April 2017</small>
    </div>
</div> -->
<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="card contents">
        <div class="row">
          <div class="col-md-12">
            <h3 class="contents-header">Contents</h3>
          </div>
        </div>
      <div class="row">


      <div class="col-md-6">
        <ul><li>
        <div><a href="https://www.youtube.com/watch?v=C6-qCnIsNjs">Program Goals, Objectives and Performance Indicators</a>&nbsp;&nbsp;&raquo;</div></li>


        <li><div ><a href="https://www.youtube.com/watch?v=rop6xoEA_NQ">The Value of Logic Models (Part 1)</a>&nbsp;&nbsp;&raquo;</div></li>
        <li><div ><a href="https://www.youtube.com/watch?v=1bGkwPgwmcw" >Major Components of a Logic Model (Part 2)</a>&nbsp;&nbsp;&raquo;</div></li>
        <li><div ><a href="https://www.youtube.com/watch?v=6O5YP5d2iTs" >How Logic Models Support Implementation (Part 3)</a>&nbsp;&nbsp;&raquo;</div></li>
      <li>
        <div><a href="https://www.youtube.com/watch?v=iHsWphZtbzU" >Amendments to Grant Agreements</a>&nbsp;&nbsp;&raquo;</div>
      </li></ul>
      </div>

      <div class="col-md-6">
        <ul>
        <li>
          <div>
            <a href="https://www.youtube.com/watch?v=YjkFmPid5DI" >Budget Categories Needing Prior Approval</a>&nbsp;&nbsp;&raquo;
          </div>
        </li>

        <li>
          <div>
            <a href="https://www.youtube.com/watch?v=nQb8pK5e3Mo" >Budget Category: Travel Costs</a>&nbsp;&nbsp;&raquo;
          </div>
        </li>

        <li>
          <div>
            <a href="https://www.youtube.com/watch?v=zXIopZ4KeEI" >Budget Category: Subcontractors</a>&nbsp;&nbsp;&raquo;
          </div>
        </li>

        <li>
          <div>
            <a href="https://www.youtube.com/watch?v=4stkASoNY5w" >Budget Category: Indirect Costs</a>&nbsp;&nbsp;&raquo;
          </div>
        </li>

        <li>
          <div>
            <a href="https://www.youtube.com/watch?v=x6cqf0075Fg" >Faith-Based Program Self Reporting Form</a>&nbsp;&nbsp;&raquo;
          </div>
        </li>




      </ul>
      </div>
        </div>
      </div>


<div class="card well" id="program-goals">
<h2 class="h4" >Program Goals, Objectives and Performance Indicators</h2>
<p>View a webinar describing Goals, Objectives, and Performance
  Indicators to assist in the process of grant and program development.</p>
  <div class="card" style="width: 16rem; margin-left: auto; margin-right: auto ;">
   <span class="card-img-top youtube" id="C6-qCnIsNjs" style="height: 200px" alt="Card image cap"></span>

   <div class="card-footer">
       <small class="text-muted">Added April 2017</small>
     </div>
 </div>
 </div>




<div class="card well" id="logic-models">
 <h2 class="h4">Logic Models</h2>
<p>View this Logic Model webinar series to assist in the process of program planning and development.</p>


<div class="card-deck text-center" style="margin-left: auto; margin-right: auto ;">
<div class="card" style="width: 15rem">
  <span class="card-img-top youtube" id="rop6xoEA_NQ" style="height: 200px" alt="Card image cap"></span>
   <div class="card-block">
     <h4 class="card-title">The Value of Logic Models (Part 1)</h4>

   </div>
   <div class="card-footer">
       <small class="text-muted">Added April 2017</small>
     </div>
 </div>

 <div class="card" style="width: 15rem" >
   <span class="card-img-top youtube" id="1bGkwPgwmcw" style="height: 200px" alt="Card image cap"></span>
    <div class="card-block">
      <h4 class="card-title">Major Components of a Logic Model (Part 2)</h4>

    </div>
    <div class="card-footer">
        <small class="text-muted">Added April 2017</small>
      </div>
  </div>
  <div class="card" style="width: 15rem">
    <span class="card-img-top youtube" id="6O5YP5d2iTs" style="height: 200px" alt="Card image cap"></span>
     <div class="card-block">
       <h4 class="card-title">How Logic Models Support Implementation (Part 3)</h4>

     </div>
     <div class="card-footer">
         <small class="text-muted">Added April 2017</small>
       </div>
   </div>
  </div>
</div>



<div class="card well" id="amendments">
<h2 class="h4">Amendments to Grant Agreements</h2>
<p>View a webinar on the process of amending an existing Authority grant agreement.
</p>
  <div class="card" style="width: 16rem; margin-left: auto; margin-right: auto ;">
   <span class="card-img-top youtube" id="iHsWphZtbzU" style="height: 200px" alt="Card image cap"></span>

   <div class="card-footer">
       <small class="text-muted">Added April 2017</small>
     </div>
 </div>
 </div>


 <div class="card well" id="prior-approval">
 <h2 class="h4">Budget Categories Needing Prior Approval</h2>
 <p>View a webinar describing items that require Prior Approvals and/or Additional Justifications (even if they are detailed in the agreement narrative and budget).
 </p>
   <div class="card" style="width: 16rem; margin-left: auto; margin-right: auto ;">
    <span class="card-img-top youtube" id="YjkFmPid5DI" style="height: 200px" alt="Card image cap"></span>

    <div class="card-footer">
        <small class="text-muted">Added April 2017</small>
      </div>
  </div>
  </div>



  <div class="card well" id="travel-costs">
  <h2 class="h4">Budget Category: Travel Costs</h2>
  <p>View a webinar describing Travel Costs and State Travel Guidelines.
  </p>
    <div class="card" style="width: 16rem; margin-left: auto; margin-right: auto ;">
     <span class="card-img-top youtube" id="nQb8pK5e3Mo" style="height: 200px" alt="Card image cap"></span>

     <div class="card-footer">
         <small class="text-muted">Added April 2017</small>
       </div>
   </div>
   </div>


   <div class="card well" id="subcontractors">
   <h2 class="h4">Budget Category: Subcontractors</h2>
   <p>This webinar describes the Subcontract Approval process and
     required Consultant/Contractor/Vendor documentation.

   </p>
     <div class="card" style="width: 16rem; margin-left: auto; margin-right: auto ;">
      <span class="card-img-top youtube" id="zXIopZ4KeEI" style="height: 200px" alt="Card image cap"></span>

      <div class="card-footer">
          <small class="text-muted">Added April 2017</small>
        </div>
    </div>
    </div>


    <div class="card well" id="indirect-costs">
    <h2 class="h4">Budget Category: Indirect Costs</h2>
    <p>View a webinar on Indirect Costs.

    </p>
      <div class="card" style="width: 16rem; margin-left: auto; margin-right: auto ;">
       <span class="card-img-top youtube" id="4stkASoNY5w" style="height: 200px" alt="Card image cap"></span>

       <div class="card-footer">
           <small class="text-muted">Added April 2017</small>
         </div>
     </div>
     </div>

     <div class="card well" id="self-reporting">
     <h2 class="h4">Faith-Based Program Self Reporting Form</h2>
     <p>View a webinar on how to complete the Authority's Faith-Based Program Self Reporting Form.

     </p>
       <div class="card" style="width: 16rem; margin-left: auto; margin-right: auto ;">
        <span class="card-img-top youtube" id="x6cqf0075Fg" style="height: 200px" alt="Card image cap"></span>

        <div class="card-footer">
            <small class="text-muted">Added April 2017</small>
          </div>
      </div>
      </div>


      <!-- <div class="video-embed">
<div class="youtube"
     id="nFVMlof28nU"
     style="width: 340px; height: 220px;">


</div>
<div class="caption text-center">Video webinar title 1</div>
</div> -->














</div>
    </div>
  </div>
  </section>
</template>

<script>

const description = `Webinars`
const title = "Webinars"
const created = '2017-03-24'
const type  = 'page'
const status = 'live'
import utilities from '@/utilities'
import PageHeader from '@/components/PageHeader'

export default {
  name: 'Webinars',
  pageData:  {
    created,
    description,
    title,
    type,
    status
  },
  metaInfo: {
      // title will be injected into parent titleTemplate
      title,
      meta: [
        { vmid: 'description', name: 'description', content: utilities.stripTags(description)}
    ]
  },
  data () {
    return {
      title
    }
  },
  components: {

    PageHeader

  },

  mounted () {
      $( document ).ready(function() {

          $(function() {
            $(".youtube").each(function() {
        // Based on the YouTube ID, we can easily find the thumbnail image
        $(this).css('background-image', 'url(https://i.ytimg.com/vi/' + this.id + '/mqdefault.jpg)');

        // Overlay the Play icon to make it look like a video player
        $(this).append($('<div/>', {'class': 'play'}));

        $(document).delegate('#'+this.id, 'click', function() {
            // Create an iFrame with autoplay set to true
            var iframe_url = "https://www.youtube.com/embed/" + this.id + "?allowfullscreen&autoplay=1&autohide=1";
            if ($(this).data('params')) iframe_url+='&'+$(this).data('params');

            // The height and width of the iFrame should be the same as parent
            var iframe = $('<iframe/>', {'frameborder': '0', 'allowfullscreen':'true','src': iframe_url, 'width': $(this).width(), 'height': $(this).height() })

            // Replace the YouTube thumbnail with YouTube HTML5 Player
            $(this).replaceWith(iframe);
        });
    });
 });

      });
  }
}
</script>

<style lang="css" scoped>
a {text-decoration: none}
/*.card {margin-top: 30px; margin-bottom: 30px}
.card-img-top {border-bottom: 1px solid #ccc;}
.card-footer small {font-weight: 700}
.card.well {padding: 35px; background: #efefef}
.text-muted {color: #aaa}
.contents-header {border-bottom: 1px solid #ccc; padding-bottom: 8px; margin-bottom: 30px}
.card.contents {padding: 30px; margin-bottom: 100px}*/
ul li {margin-top: 0; padding-top: 0}
</style>



// WEBPACK FOOTER //
// Webinars.vue?084e9aa2